<script lang="ts">
	import {
		Button,
		Container,
		IconButton,
		SidepanelContent,
		Text,
	} from '@Shelly/shelly-design-system/index';
	import GroupDeleteModal from 'src/components/Lists/Groups/GroupDeleteModal.svelte';
	import { copy } from 'src/helpers/copy_text';
	import { canManageHomeEntities } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';
	import { format } from 'svelte-i18n';

	export let group;

	let showDeleteGroupModal = false;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);
</script>

<SidepanelContent>
	<Container backgroundColor="color-0" padding="xs">
		<Text styleType="label-large" class="text-center mb-s-plus">
			{$format('group_id', { default: 'Group id' })}
		</Text>
		<div class="d-flex justify-content-center align-items-center">
			<Text class="text-break-all text-center" styleType="body">{group.id}</Text>

			<IconButton
				aria-label={$format('button_copy_scene_id', {
					default: 'Button copy scene id',
				})}
				class="ml-s"
				icon="fas fa-copy"
				on:click={() =>
					copy(
						group.id,
						$format('copied_successfully', {
							default: 'Copied successfully!',
						}),
					)}
			/>
		</div>
	</Container>

	{#if isSharedHomeActive}
		<SharedHomeOwnerManagedAlert class="mt-s" context="delete_entity" />
	{/if}
	<Button
		class="mt-s"
		width="full"
		size="m"
		variant="danger"
		icon="fas fa-trash"
		disabled={isSharedHomeActive}
		aria-label={$format('button_delete_group', {
			default: 'Delete group',
		})}
		on:click={() => (showDeleteGroupModal = true)}
	>
		{$format('button_delete_group', {
			default: 'Delete group',
		})}
	</Button>
</SidepanelContent>

<GroupDeleteModal bind:showDeleteGroupModal editGroup={group} />
